import {Component, Inject, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {ActivatedRoute, Data} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AbstractComponent, AddUserModalComponent, AddUserResult, ConfirmationModalComponent} from "@components";
import {User, UserDetail} from "@model";
import {AdministratorsService, ExportService, TOAST_STATE, ToastService} from "@services";
import { FindOrganisersRequest } from 'src/app/model/find-organisers-request';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { environment } from '@environment';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-list-of-administrators',
  templateUrl: './list-of-administrators.component.html',
  styleUrls: ['./list-of-administrators.component.scss']
})
export class ListOfAdministratorsComponent extends AbstractComponent {
  @Input() administrators: UserDetail[] = [];
  @ViewChild('deleteDialog') deleteDialog: TemplateRef<UserDetail> = {} as TemplateRef<UserDetail>;
  filteredAdmins: UserDetail[] =[];
  currentUserDetails: UserDetail | undefined;
  name: string = "";

  constructor(private translocoService: TranslocoService, private modalService: NgbModal,
              private administratorService: AdministratorsService, private toastService: ToastService, private route: ActivatedRoute,
              private exportService: ExportService, @Inject(DOCUMENT) private document: Document) {
    super();
  }
  ngOnInit() {
    this.subsribeToRouteDataChange();
  }

  openAddNewAdminUserModal() {
    const modalRef = this.modalService.open(AddUserModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.title = this.translocoService.translate("administrator.list.add.new");
    modalRef.componentInstance.isAdmin = true;
    modalRef.result.then((result: AddUserResult) => {
      this.onAddAdministrator(result.email!);
    }, (_) => {
      /// ignore
    });
  }

  subsribeToRouteDataChange() {
    this.subscriptions.push(this.route.queryParams.pipe(debounceTime(environment.fullTextSearchDelay),
        distinctUntilChanged()).subscribe((queryParams: any) => {
        this.name = queryParams.name ? queryParams.name : "";
        this.filterAdministrators();
      })
    );
  }
  filterAdministrators() {
    let filtered: UserDetail[] = this.administrators.filter((admin: UserDetail) => this.filterFunction(admin));
    this.filteredAdmins = filtered.length > 0 ? filtered : [];
  }
  filterFunction(admin: UserDetail): boolean {
    if (this.name) {
      let filterName: string = this.name.toLowerCase() ?? "";
      return !!(admin.firstname?.toLowerCase().includes(filterName) ||admin.lastname?.toLowerCase().includes(filterName)||
        admin.email?.toLowerCase().includes(filterName));
    }
    return true;
  }

  onAddAdministrator(email: string): void {
    this.administratorService.addAdministrator(email).subscribe((result: boolean) => {
      if (result) {
        this.toastService.showToast(TOAST_STATE.success,
          this.translocoService.translate("administrator.list.add.success"));
        this.administratorService.findAdministrators(true).subscribe((users: UserDetail[]) => {
          this.administrators = users;
        })
      } else {
        this.toastService.showToast(TOAST_STATE.danger,
          this.translocoService.translate("administrator.list.add.error"));
      }
    })
  }

  openDeleteAdministratorDialog(user: UserDetail) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.title = this.translocoService.translate("administrator.list.delete.dialog.title");
    modalRef.componentInstance.text = this.translocoService.translate("administrator.list.delete.dialog.text");

    modalRef.result.then((_) => {
      this.onDeleteAdministrator(user);
    }, (_) => {
      /// ignore
    });
  }

  onDeleteAdministrator(user: UserDetail): void {
    this.administratorService.deleteAdministrator(user.userId!).subscribe((result: boolean) => {
      if (result) {
        this.toastService.showToast(TOAST_STATE.success,
          this.translocoService.translate("administrator.list.delete.success"));
        this.administratorService.findAdministrators(true).subscribe((users: UserDetail[]) => {
          this.administrators = users;
        })
      } else {
        this.toastService.showToast(TOAST_STATE.danger,
          this.translocoService.translate("administrator.list.delete.error"));
      }
    })
  }
  getFileFromServer(type: string) {
    this.exportService.downloadAdmins(type, this.createFilter()).subscribe(
      (blob: Blob) => {
        const formattedDateTime: string = this.getCurrentDateTimeFormatted();
        const filename: string = type + '_' + formattedDateTime + '.' + type;
        const downloadLink: HTMLAnchorElement = this.document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', filename);
        this.document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      error => {
        console.error('Error downloading file:', error);
      }
    );
  }
  getCurrentDateTimeFormatted(): string {
    const currentDateTime = new Date();
    const year = currentDateTime.getFullYear();
    const month = this.padNumber(currentDateTime.getMonth() + 1, 2);
    const day = this.padNumber(currentDateTime.getDate(), 2);
    return `${year}-${month}-${day}`;
  }

  padNumber(num: number, size: number): string {
    let numStr = num.toString();
    while (numStr.length < size) {
      numStr = '0' + numStr;
    }
    return numStr;
  }
  createFilter() {
    return FindOrganisersRequest.createOrganisersRequest( {text: this.name !== "" ? this.name : undefined});
  }
}
